import * as Yup from 'yup';
import { differenceInYears } from 'date-fns';

// Shared birth_date validation for family members (used by the seller-public
// complete-profile dialog and the dashboard edit dialog), so both enforce the
// same age rules:
//   - child:  age <= maxAge   -> family.age_exceeds_limit
//   - adult:  age >  maxAge    -> family.age_below_adult_min
// Age rules only apply when maxAge (familyChildMaxAge) is configured; otherwise
// birth_date is just required/optional.
export function buildBirthDateSchema({ isChild, maxAge, required, translate }) {
    let schema = required
        ? Yup.mixed().required(translate('dashboard.events.required_field'))
        : Yup.mixed().nullable();

    const max = Number(maxAge);
    const hasMaxAge = maxAge !== null && maxAge !== undefined && maxAge !== '' && !Number.isNaN(max);
    if (!hasMaxAge) return schema;

    if (isChild) {
        schema = schema.test(
            'child-max-age',
            translate('family.age_exceeds_limit', { maxAge: max }),
            (value) => !value || differenceInYears(new Date(), new Date(value)) <= max,
        );
    } else {
        schema = schema.test(
            'adult-min-age',
            translate('family.age_below_adult_min', { maxAge: max }),
            (value) => !value || differenceInYears(new Date(), new Date(value)) > max,
        );
    }

    return schema;
}
